import {Component, OnInit, ViewChild} from '@angular/core';
import {combineLatestAll, of, Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {PrlFinanceService} from '../../services/prl-finance.service';
import {MxPreloaderService, withPreloader} from 'mx-core';
import {PaymentAccountPrlObj, PaymentRequestPropertiesPrlObj} from '../../../../../../generated/generated.model';
import {PrlPaymentAccountsService} from '../../services/prl-payment-accounts.service';
import {PrlPanelComponent} from '../../../../shared/components/prl-panel/prl-panel.component';

@Component({
    selector: 'prl-finance',
    templateUrl: './prl-finance.component.html',
    standalone: false,
    styleUrls: ['./prl-finance.component.scss']
})
export class PrlFinanceComponent implements OnInit {

    @ViewChild('paymentRequests') paymentRequests!: PrlPanelComponent;

    protected isMobile: boolean = false;
    protected showPaymentAccount = false;
    protected paymentsPerMerchant = false;
    protected isAffiliatePayable = false;
    protected isDataLoaded = false;
    private destroy$$: Subject<null> = new Subject<null>();

    constructor(
        protected financeService: PrlFinanceService,
        protected paymentAccountsService: PrlPaymentAccountsService,
        private preloader: MxPreloaderService
    ) {
    }

    ngOnInit(): void {
        this.financeService.setNewPaymentRequest(false);
        of(
            this.financeService.showPaymentAccounts(),
            this.financeService.isBalancePerMerchant(),
            this.financeService.isAffiliatePayable(),
            this.financeService.getPaymentRequestProperties(),
            this.paymentAccountsService.getPaymentAccountsFromDB()
        ).pipe(takeUntil(this.destroy$$), withPreloader(this.preloader), combineLatestAll())
            .subscribe((response) => {
                this.showPaymentAccount = response[0] as boolean;
                this.paymentsPerMerchant = response[1] as boolean;
                this.isAffiliatePayable = response[2] as boolean;
                this.financeService.setTotalPaymentRequestProperties(response[3] as PaymentRequestPropertiesPrlObj);
                this.paymentAccountsService.setPaymentAccounts(response[4] as Array<PaymentAccountPrlObj>);
                this.isDataLoaded = true;
            });
    }

    protected onExpandPaymentRequest(event: boolean) {
        if (!this.paymentsPerMerchant) {
            this.financeService.closePaymentRequest.subscribe(() => {
                this.paymentRequests?.panel.close();
            });
            this.financeService.setNewPaymentRequest(event);
        }
    }
}
